import React from 'react';
import { ListHeader, EmployeeBalanceTab } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var PartnerCashDeskEmployeeBalance = function PartnerCashDeskEmployeeBalance() {
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ListHeader, {
    title: "\u0411\u0430\u043B\u0430\u043D\u0441 \u0441\u043B\u0443\u0436\u0438\u0442\u0435\u043B\u0438"
  }), ___EmotionJSX(EmployeeBalanceTab, null));
};

export default PartnerCashDeskEmployeeBalance;